import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  IconButton,
  Link,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import { FC, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { HeaderLogo } from "src/assets/icons/header-logo-ID_TAG_BRAND";
import { isAuthorized } from "src/config/store/slices/auth/auth.slice";
import { useIsMobileView } from "src/modules/shared/hooks/use-is-mobile-view";
import { BuildInfo } from "../../build-info/build-info";
import { CustomButton } from "../../custom-button/custom-button";
import { MobileDrawer } from "../../mobile-drawer/mobile-drawer";
import { CurrentUser } from "./current-user/current-user";
import { classes, headerHeight, mobileHeaderHeight } from "./header.styles";

export const Header: FC = () => {
  const isMobile = useIsMobileView();
  const small = useMediaQuery("(max-height:600px)");

  const [mobileMenu, setMobileMenu] = useState(false);

  const user = useSelector(isAuthorized);

  const handleMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <>
      <AppBar
        position="sticky"
        color="transparent"
        sx={classes.appBar}
        elevation={0}
      >
        <Toolbar
          sx={{
            ...classes.toolbar,
            justifyContent:
              isMobile && user
                ? "space-between"
                : { xs: "center", sm: "space-between" },
            height: small
              ? mobileHeaderHeight
              : { xs: mobileHeaderHeight, sm: headerHeight },
          }}
        >
          {isMobile && user && (
            <IconButton color="primary" edge="end" onClick={handleMenu}>
              <MenuIcon />
            </IconButton>
          )}

          <Box sx={classes.logo}>
            <NavLink to={"/"}>
              <HeaderLogo />
            </NavLink>
          </Box>

          {!isMobile && (
            <Box sx={classes.actions}>
              {process.env.REACT_APP_ENV === "development" && !isMobile && (
                <BuildInfo />
              )}

              {user ? (
                <CurrentUser clickable />
              ) : (
                <Link
                  sx={{ textDecoration: "none" }}
                  href="https://www.idtagtech.com"
                  target="blank"
                >
                  <CustomButton variant="outlined" buttonType="secondary">
                    Get in touch
                  </CustomButton>
                </Link>
              )}
            </Box>
          )}
        </Toolbar>
      </AppBar>
      {isMobile && (
        <MobileDrawer
          isOpen={mobileMenu}
          onClose={() => {
            setMobileMenu(false);
          }}
        />
      )}
    </>
  );
};
